import React, { Component } from 'react'
import { Form, Field } from 'react-final-form'
import Datetime from 'react-datetime'
import moment from 'moment'
import { compose, graphql, Query } from 'react-apollo'

// material-ui components
import withStyles from 'material-ui/styles/withStyles'
import TextField from 'components/TextField/TextField'
import FormControl from 'material-ui/Form/FormControl'
import InputLabel from 'material-ui/Input/InputLabel'

import Button from 'material-ui/Button'
import IconButton from 'material-ui/IconButton'
import Phone from 'material-ui-icons/Phone'
import Email from 'material-ui-icons/Email'

// custom Fields
import ZoneField from './ZoneField'
import InteressiField from './InteressiField'

// graphql
import agenti from 'graphql/queries/agenti'
import updateCliente from 'graphql/mutations/updateCliente'
import createCliente from 'graphql/mutations/createCliente'

// styles
import extendedFormsStyle from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx'
import './Dati.css'

class FormCliente extends Component {
  onSubmit = async (values) => {
    const cliente = { ...values }
    const zone = cliente.zone ? cliente.zone.map((zona) => zona.value).join(',') : ''
    const interessi = cliente.interessi
      ? cliente.interessi.map((interesse) => interesse.value).join(',')
      : ''

    const clienteToSave = {
      nome: cliente.nome,
      comune: cliente.comune,
      email: cliente.email || null,
      email2: cliente.email2 || null,
      telefono: cliente.telefono,
      telefono2: cliente.telefono2 || null,
      agenteId: cliente.agenteId ? cliente.agenteId : null,
      dataNascita: cliente.dataNascita ? moment(cliente.dataNascita).format('YYYY-MM-DD') : null,
      lingua: cliente.lingua ? cliente.lingua : null,
      tipoPnl: cliente.tipoPnl || null,
      famiglia: cliente.famiglia || '',
      percheCompra: cliente.percheCompra || '',
      quandoInteressato: cliente.quandoInteressato || null,
      quantoInteressato: cliente.quantoInteressato >= 0 ? cliente.quantoInteressato : null,
      voto: cliente.voto || null,
      daRicontattare: cliente.daRicontattare,
    }

    if (!this.props.cliente) {
      this.props
        .createCliente({
          variables: {
            cliente: clienteToSave,
            zone,
            interessi,
          },
        })
        .then(() => this.props.onSaved())
    } else {
      this.props
        .updateCliente({
          variables: {
            id: values.id,
            cliente: clienteToSave,
            zone,
            interessi,
          },
        })
        .then(() => this.props.onSaved())
    }
  }

  validate = (values) => {
    const errors = {}
    if (!values.nome) {
      errors.nome = 'Richiesto'
    }
    if (!values.comune) {
      errors.comune = 'Richiesto'
    }
    if (values.email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
      errors.email = 'Indirizzo email non valido'
    }
    if (!values.telefono) {
      errors.telefono = 'Richiesto'
    }
    if (!values.agenteId && values.agenteId !== 0) {
      errors.agenteId = 'Richiesto'
    }
    return errors
  }

  render() {
    const { cliente, isAgente, utenteId, classes } = this.props
    let initialValues = {}

    if (cliente) {
      initialValues = {
        id: cliente.id,
        nome: cliente.nome,
        comune: cliente.comune,
        email: cliente.email,
        email2: cliente.email2,
        telefono: cliente.telefono,
        telefono2: cliente.telefono2,
        agenteId: cliente.agenteId,
        dataNascita: cliente.dataNascita ? moment(cliente.dataNascita).toDate() : null,
        lingua: cliente.lingua,
        tipoPnl: cliente.tipoPnl,
        famiglia: cliente.famiglia,
        percheCompra: cliente.percheCompra,
        quandoInteressato: cliente.quandoInteressato,
        quantoInteressato: cliente.quantoInteressato,
        voto: cliente.voto,
        zone: cliente.zone.map((zona) => ({
          value: zona.nome,
          label: zona.nome,
        })),
        interessi: cliente.interessi.map((interesse) => ({
          value: interesse.nome,
          label: interesse.nome,
        })),
      }
    } else {
      initialValues = {
        daRicontattare: true,
      }
    }

    return (
      <div className="form-cliente">
        <Form
          onSubmit={this.onSubmit}
          initialValues={initialValues}
          validate={this.validate}
          render={({ handleSubmit, reset, submitting, pristine, values }) => (
            <form onSubmit={handleSubmit}>
              <Button
                style={{ marginTop: 20, marginBottom: 20 }}
                className="save-button"
                type="submit"
                disabled={submitting || (isAgente && cliente.agenteId !== utenteId)}
                variant="raised"
                color="primary"
              >
                {cliente ? 'Salva modifiche' : 'Crea cliente'}
              </Button>

              <Field
                name="nome"
                label="Nome"
                type="text"
                margin="normal"
                fullWidth
                component={TextField}
              />

              <Field
                name="comune"
                label="Comune"
                type="text"
                margin="normal"
                fullWidth
                component={TextField}
              />

              <div className="icon-field" style={{ position: 'relative', paddingRight: 50 }}>
                <Field
                  name="email"
                  label="Email"
                  type="email"
                  margin="normal"
                  fullWidth
                  component={TextField}
                />
                <div className="icon" style={{ position: 'absolute', bottom: 6, right: 0 }}>
                  <IconButton
                    className={classes.button}
                    href={`mailto:${values.email}`}
                    disabled={!values.email}
                    color="primary"
                    style={{ display: 'block', padding: 10 }}
                  >
                    <Email />
                  </IconButton>
                </div>
              </div>

              <div className="icon-field" style={{ position: 'relative', paddingRight: 50 }}>
                <Field
                  name="email2"
                  label="Email 2"
                  type="email"
                  margin="normal"
                  fullWidth
                  component={TextField}
                />
                <div className="icon" style={{ position: 'absolute', bottom: 6, right: 0 }}>
                  <IconButton
                    className={classes.button}
                    href={`mailto:${values.email2}`}
                    disabled={!values.email2}
                    color="primary"
                    style={{ display: 'block', padding: 10 }}
                  >
                    <Email />
                  </IconButton>
                </div>
              </div>

              <div className="icon-field" style={{ position: 'relative', paddingRight: 50 }}>
                <Field
                  name="telefono"
                  label="Telefono"
                  type="text"
                  margin="normal"
                  fullWidth
                  component={TextField}
                />
                <div className="icon" style={{ position: 'absolute', bottom: 6, right: 0 }}>
                  <IconButton
                    className={classes.button}
                    href={`tel:${values.telefono}`}
                    disabled={!values.telefono}
                    color="primary"
                    style={{ display: 'block', padding: 10 }}
                  >
                    <Phone />
                  </IconButton>
                </div>
              </div>

              <div className="icon-field" style={{ position: 'relative', paddingRight: 50 }}>
                <Field
                  name="telefono2"
                  label="Telefono 2"
                  type="text"
                  margin="normal"
                  fullWidth
                  component={TextField}
                />
                <div className="icon" style={{ position: 'absolute', bottom: 6, right: 0 }}>
                  <IconButton
                    className={classes.button}
                    href={`tel:${values.telefono2}`}
                    disabled={!values.telefono2}
                    color="primary"
                    style={{ display: 'block', padding: 10 }}
                  >
                    <Phone />
                  </IconButton>
                </div>
              </div>

              <Query
                query={agenti}
                variables={{
                  limit: 20,
                }}
              >
                {({ loading, error, data }) => {
                  if (loading) return <p>Loading...</p>
                  if (error) return <p>Error :(</p>

                  let agentiOptions = data.utenti.nodes.map((agente) => ({
                    value: agente.id,
                    label: agente.nome,
                  }))

                  if (!cliente) {
                    agentiOptions.unshift({
                      value: 0,
                      label: 'ASSEGNAMENTO AUTOMATICO',
                    })
                  }

                  return (
                    <Field
                      name="agenteId"
                      label="Agente"
                      margin="normal"
                      select
                      fullWidth
                      disabled={isAgente && cliente.agenteId !== utenteId}
                      component={TextField}
                      options={agentiOptions}
                    />
                  )
                }}
              </Query>

              <div style={{ marginTop: 30, padding: 10, backgroundColor: '#d9ebf5' }}>
                <h3 style={{ marginTop: 0 }}>Zone</h3>
                <Field name="zone" component={ZoneField} />
              </div>

              <div
                style={{ marginTop: 30, padding: 10, backgroundColor: '#e5f3d3', marginBottom: 30 }}
              >
                <h3 style={{ marginTop: 0 }}>Interessi</h3>
                <Field name="interessi" component={InteressiField} />
              </div>

              <InputLabel className={classes.label} style={{ color: '#757575', fontSize: 16 }}>
                Data di nascita
              </InputLabel>
              <br />
              <FormControl fullWidth>
                <Field
                  name="dataNascita"
                  type="text"
                  margin="normal"
                  fullWidth
                  render={({ input, meta }) => (
                    <Datetime {...input} dateFormat="DD/MM/YYYY" timeFormat={false} />
                  )}
                />
              </FormControl>

              <Field
                name="lingua"
                label="Lingua"
                margin="normal"
                select
                fullWidth
                component={TextField}
                options={[
                  { value: '', label: '-- Seleziona --' },
                  { value: 'en', label: 'Inglese' },
                  { value: 'it', label: 'Italiano' },
                ]}
              />

              <Field
                name="tipoPnl"
                label="Tipo PNL"
                margin="normal"
                select
                fullWidth
                component={TextField}
                options={[
                  { value: '', label: '-- Seleziona --' },
                  { value: 'VISIVO', label: 'Visivo' },
                  { value: 'AUDITIVO', label: 'Auditivo' },
                  { value: 'CINESTESICO', label: 'Cinestesico' },
                ]}
              />

              <Field
                name="famiglia"
                label="Famiglia"
                type="text"
                margin="normal"
                fullWidth
                // multiline
                // rows="3"
                component={TextField}
              />

              <Field
                name="percheCompra"
                label="Perché compra?"
                margin="normal"
                fullWidth
                multiline
                rows="3"
                component={TextField}
              />

              <Field
                name="quandoInteressato"
                label="Quando è interessato?"
                margin="normal"
                select
                fullWidth
                component={TextField}
                options={[
                  { value: '', label: '-- Seleziona --' },
                  { value: 'ADESSO', label: 'Adesso' },
                  { value: 'TRA_UN_MESE', label: 'Tra un mese' },
                  { value: 'TRA_UN_ANNO', label: 'Tra un anno' },
                  { value: 'TRA_OLTRE_UN_ANNO', label: 'Tra oltre un anno' },
                ]}
              />

              <Field
                name="quantoInteressato"
                label="Quanto è interessato?"
                margin="normal"
                select
                fullWidth
                component={TextField}
                options={[
                  { value: '', label: '-- Seleziona --' },
                  { value: 5, label: '⭐⭐⭐⭐⭐' },
                  { value: 4, label: '⭐⭐⭐⭐' },
                  { value: 3, label: '⭐⭐⭐' },
                  { value: 2, label: '⭐⭐' },
                  { value: 1, label: '⭐' },
                  { value: 0, label: '❌' },
                ]}
              />

              <Field
                name="voto"
                label="Voto"
                margin="normal"
                select
                fullWidth
                component={TextField}
                options={[
                  { value: '', label: '-- Seleziona --' },
                  { value: 1, label: 'Perditempo' },
                  { value: 2, label: 'Scadente' },
                  { value: 3, label: 'Discreto' },
                  { value: 4, label: 'Buono' },
                  { value: 5, label: 'Molto buono' },
                  { value: 6, label: 'Eccellente' },
                ]}
              />

              <Button
                style={{ marginTop: 20 }}
                className="save-button"
                type="submit"
                disabled={submitting || (isAgente && cliente.agenteId !== utenteId)}
                variant="raised"
                color="primary"
              >
                {cliente ? 'Salva modifiche' : 'Crea cliente'}
              </Button>
            </form>
          )}
        />
      </div>
    )
  }
}

export default compose(
  graphql(createCliente, { name: 'createCliente' }),
  graphql(updateCliente, { name: 'updateCliente' }),
  withStyles(extendedFormsStyle)
)(FormCliente)



// WEBPACK FOOTER //
// ./src/views/App/Clienti/FormCliente.jsx